export default __webpack_public_path__ + "static/media/20240504-SPLK-1002 Certificate.eb73346f.jpg";